// <countdown-timer data-duration="600" data-key="cart-token"> shows mm:ss and hides its banner at 0.
// The end time is kept in sessionStorage per cart, so re-rendering the cart drawer does not restart it.
if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        const duration = parseInt(this.dataset.duration, 10) || 600;
        const key = 'caeyo-cart-timer-' + (this.dataset.key || 'cart');
        let end = null;
        try {
          end = parseInt(sessionStorage.getItem(key), 10) || null;
        } catch (e) {}
        if (!end) {
          end = Date.now() + duration * 1000;
          try {
            sessionStorage.setItem(key, String(end));
          } catch (e) {}
        }
        const banner = this.closest('.cart-timer');
        const tick = () => {
          const left = Math.max(0, Math.round((end - Date.now()) / 1000));
          if (left === 0) {
            if (banner) banner.hidden = true;
            clearInterval(this.interval);
            return;
          }
          const minutes = String(Math.floor(left / 60)).padStart(2, '0');
          const seconds = String(left % 60).padStart(2, '0');
          this.textContent = minutes + ':' + seconds;
        };
        tick();
        this.interval = setInterval(tick, 1000);
      }
      disconnectedCallback() {
        clearInterval(this.interval);
      }
    }
  );
}
